import Link from 'next/link';
import React from 'react';

interface LinkNextProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  href?: string;
}

export const LinkNext = ({ children, href, ...props }: LinkNextProps) => {
  if (!href) {
    return <>{children}</>;
  }

  return (
    <Link href={href}>
      <a {...props}>{children}</a>
    </Link>
  );
};

